import { render, staticRenderFns } from "./BankJobForm.vue?vue&type=template&id=26222418&scoped=true"
import script from "./BankJobForm.vue?vue&type=script&lang=js"
export * from "./BankJobForm.vue?vue&type=script&lang=js"
import style0 from "./BankJobForm.vue?vue&type=style&index=0&id=26222418&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26222418",
  null
  
)

export default component.exports